import React, { useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import { toastr } from 'react-redux-toastr';
import api from '../../api';
import { Dict } from '../../core';
import { MediaFile } from '../../core/api/models';
import FileUploadView from './FileUploadView';

const FileUploadController: React.FunctionComponent<{
  control: Control;
  name: string;
  setValue: (field: string, value: any) => void;
  value?: MediaFile;
  error?: string;
  label: string;
  required?: boolean;
  supportedFormats?: string[];
}> = (props) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState<File>();

  const onProgress = (event: ProgressEvent) => {
    const progressPercentage = event.loaded / event.total;
    setProgress(progressPercentage);
  };

  const uploadFile = async (fl: File) => {
    setFile(fl);
    setUploading(true);
    try {
      const uploadedResponse = await api.upload.upload(fl, onProgress);
      props.setValue(props.name, uploadedResponse.data);
    } catch (e) {
      toastr.error('Error', 'File upload failed');
    }
    setUploading(false);
    setFile(undefined);
  };

  const closeFile = () => {
    setUploading(false);
    props.setValue(props.name, undefined);
    setFile(undefined);
  };

  const rules: Dict = {
    validate: {
      uploadingCompleted: () =>
        !uploading || 'Please wait till the uploading completed',
    },
  };
  if (!uploading && props.required) {
    rules.required = `${props.label} is required`;
  }

  return (
    <>
      <Controller
        control={props.control}
        name={props.name}
        rules={rules}
        defaultValue={props.value}
        render={({ name, value }) => {
          return (
            <FileUploadView
              title={props.label}
              name={name}
              id={name}
              fileName={file?.name || value?.originalname}
              supportedFormats={
                props.supportedFormats || ['jpeg', 'jpg', 'png']
              }
              onFileChosen={uploadFile}
              onFileClosed={closeFile}
              progress={progress}
              isUploading={uploading}
              isChosen={!!file || !!value?.originalname}
              fileSize={
                value?.size ? `${(value?.size || 0) / 1000} KB` : undefined
              }
              isUploadingCompleted={!!value?.originalname}
              filePath={value?.path}
            ></FileUploadView>
          );
        }}
      />
      {props.error && (
        <span className="error text-danger font-sm ">{props.error}</span>
      )}
    </>
  );
};

export default FileUploadController;
